<template>
  <div class="min-h-screen bg-gray-100 font-live test123">
    <nav class="bg-white top-0 left-0 shadow-sm fixed w-full z-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-12 sm:h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <Link :href="route('control-panel.index')">
              <img
                class="block sm:hidden h-8 sm:h-10 w-auto sharp-image"
                src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship"
              />
              <img
                class="hidden sm:block h-8 sm:h-10 w-auto sharp-image"
                src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship"
              />
              </Link>
            </div>
            <div v-if="false" class="ml-6 flex-col sm:mt-1">
              <p class="text-lg sm:text-xl font-light">
                brandpreneurship
              </p>
              <p class="text-sm">xyz</p>
            </div>
            
          </div>

          <div class="ml-6 flex float-right">



              <!-- <span class="ml-3 shadow-sm rounded-md mt-1 md:mt-2">
                <Link
                  :href="route('markencode.brand-typology.index')"
                  class="inline-flex items-center px-2 sm:px-4 py-1.5 sm:py-3 border border-transparent text-sm leading-5 font-medium rounded-md text-gray-500 hover:text-white bg-gray-300 hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-400 active:bg-gray-400 transition duration-150 ease-in-out"
                  ><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6 text-gray-500 hover:text-markencode-blue">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg></Link             ></span> -->
            </div>
        </div>
      </div>
    </nav>

    <div class="py-1">
      <main>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-12">
          <!-- Main: start -->

          <slot></slot>

          <!-- Main: end -->
        </div>
      </main>
    </div>
    
  </div>
</template>

<script>
export default {
  components: {},


};
</script>
